module.exports = __webpack_public_path__ + "media/images/aloe/logo/nephos-slate-0e819347c45ed0be01e3511a9a13f080.svg";